import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const userStore = {
  namespaced: true,
  state: {
    currentUser: {},
    currentUserType: '',
  },
  mutations: {
    SET_CURRENT_USER(state, value) {
      state.currentUser = value;
    },
    SET_CURRENT_USER_TYPE(state, value) {
      state.currentUserType = value;
    },
    CHANGE_COMPANY(state, value) {
      state.currentCompany = value;
    },
    CHANGE_ADMIN(state, value) {
      state.currentAdmin = value;
    },
  },
  actions: {
    logout() {
      let url = '../../sair'
      if(this.state.UserStore.currentUserType == 'Candidate') {
        url = '/candidate/sign_out'
      }
      return new Promise((resolve, reject) => {
        axios
          .delete(url)
          .then(resolve, reject => (
            resolve()
          ))
          .catch((error) => {
            this.errored = true;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
  getters: {
    getCurrentUser: (state) => (state.currentUser),
    currentUserIsAdmin: (state) => (state.currentUserType === 'Admin'),
    currentUserIsMasterAdmin: (state) => (state.currentUserType === 'Admin' && state.currentUser.role === 'master_admin'),
    currentUserIsCompanyUser: (state) => (state.currentUserType === 'CompanyUser'),
    currentUserIsCandidate: (state) => (state.currentUserType === 'Candidate'),
    currentUserIsCustomerContact: (state) => (state.currentUserType === 'CustomerContact'),
    userIsLoggedIn: (state) => (_.has(state.currentUser, 'id')),
  },
};

export default userStore;
